/* Codecs Config
 1. List of h264 videotypes - https://learn.microsoft.com/en-gb/windows/win32/directshow/h-264-video-types?redirectedfrom=MSDN
 2. Video type parameters and its codecs - https://wiki.whatwg.org/wiki/Video_type_parameters
*/

export const UPLOAD_VIDEO_CONFIG = {
  maxFileSize: 100_000_000, // 100 MB
  maxBitrateSize: 600, // 600 Kbps
  maxFPS: 30,
  videoCodec: {
    name: 'H264',
    codecs: ['avc1', 'H264', 'h264'],
  },
  audioCodec: {
    name: 'AAC',
    codecs: ['mp4a'],
  },
  allowedVideoType: 'video/mp4',
};
